
const DjelatnostPoliklinike = function(DS) {
    return DS.defineResource({
        name: 'DjelatnostPoliklinike',
        endpoint: 'djelatnosti'
    });
};

DjelatnostPoliklinike.$inject = ['DS'];


export {DjelatnostPoliklinike};



// WEBPACK FOOTER //
// ./app/models/djelatnost.js